// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserProfile_wrapper__jEBEs","avatarWrapper":"UserProfile_avatarWrapper__ixCGH","account":"UserProfile_account__6nKmA"};